import moment from 'moment'
import Chance from 'chance'

export const formatDate = (date, error = 'Invalid date') => {
  if (!date) return error

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  return `${months[month]} ${day}, ${year}`
}

export const getLocalDateTime = (date, error = 'Invalid date') => {
  if (!date) return error
  var localDateTime = new Date(Date.UTC(date.date.year, date.date.month - 1, date.date.day, date.time.hour, date.time.minute, date.time.second))
  var day = moment(localDateTime).format('D')
  var month = moment(localDateTime).format('M')
  var year = moment(localDateTime).format('YYYY')
  var hour = moment(localDateTime).format('HH')
  var minute = moment(localDateTime).format('m')
  var seconds = moment(localDateTime).format('s')
  var nano = moment(localDateTime).format('SSS')
  var dateObject = {
    date: {
      day: day,
      month: month,
      year: year
    },
    time: {
      hour: hour,
      minute: minute,
      second: seconds,
      nano: nano
    }
  }
  return dateObject
}

export const getLDT = () => {
  var date = new Date()
  var day = moment(date).format('D')
  var month = moment(date).format('M')
  var year = moment(date).format('YYYY')
  var hour = moment(date).format('HH')
  var minute = moment(date).format('m')
  var nano = moment(date).format('SSS')
  var seconds = moment(date).format('s')
  var dateObject = {
    date: {
      day: day,
      month: month,
      year: year
    },
    time: {
      hour: hour,
      minute: minute,
      nano: nano,
      second: seconds
    }
  }
  return dateObject
}

export const getUDT = () => {
  var date = new Date().toISOString()
  var day = moment(date).format('D')
  var month = moment(date).format('M')
  var year = moment(date).format('YYYY')
  var hour = moment(date).format('HH')
  var minute = moment(date).format('m')
  var nano = moment(date).format('SSS')
  var seconds = moment(date).format('s')
  var dateObject = {
    date: {
      day: day,
      month: month,
      year: year
    },
    time: {
      hour: hour,
      minute: minute,
      nano: nano,
      second: seconds
    }
  }
  return dateObject
}

export const generateRandomCloudWords = () => {
  var value = [[9, 1, 3], [4, 5, 15], [2, 5, 15], [1, 25, 150]].reduce(function (returns, item) {
    var weight = item[0]
    var minCount = item[1]
    var maxCount = item[2]
    var chance = new Chance()
    var count = chance.integer({min: minCount, max: maxCount})
    var words = chance.n(chance.word, count)
    words.forEach(function (word) { returns.push(word + ' ' + weight) })
    return returns
  }, []).join('\n')

  var words = value.split(/[\r\n]+/)
    .map(function (line) {
      return /^(.+)\s+(-?\d+)$/.exec(line)
    })
    .filter(function (matched) {
      return matched
    })
    .map(function (matched) {
      var text = matched[1]
      var weight = Number.parseInt(matched[2])
      return [text, weight]
    })

  return words
}

export const formatDateTime = (dateString, error = 'Invalid date') => {
  if (!dateString) return error
  var date = new Date(dateString)
  var localDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const month = localDateTime.getMonth()
  var day = localDateTime.getDate()
  var hour = localDateTime.getHours()
  if (hour >= 24) {
    day = day + 1
  }
  var amPm = 'AM'
  if (hour > 12) {
    hour = hour % 12
    amPm = 'PM'
  } else if (hour === 12) {
    amPm = 'PM'
  }
  const minutes = localDateTime.getMinutes()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm

  return `${months[month + 1]} ${day}, ${time}`
}

export const getUTCDate = (date, error = 'Invalid date') => {
  if (!date) return error
  var newDate = new Date(date)
  var timeZoneOffsetHours = newDate.getTimezoneOffset() / 60
  var timeZoneOffsetMinutes = newDate.getTimezoneOffset() % 60
  newDate.setHours(newDate.getHours() + timeZoneOffsetHours)
  newDate.setMinutes(newDate.getMinutes() + timeZoneOffsetMinutes)
  return newDate.getFullYear() + '-' + ((newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)) + '-' + newDate.getDate() + ' ' + ('0' + newDate.getHours()).slice(-2) + ':' + ('0' + newDate.getMinutes()).slice(-2) + ':' + ('0' + newDate.getSeconds()).slice(-2)
}



// WEBPACK FOOTER //
// ./src/helpers/formatters.js